import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_app_bottom_nav = _resolveComponent("app-bottom-nav")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_User = _resolveComponent("User")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_AccPageHeader = _resolveComponent("AccPageHeader")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_app_user_section = _resolveComponent("app-user-section")!
  const _component_ChangePasswordComponent = _resolveComponent("ChangePasswordComponent")!
  const _component_AccPageRightNav = _resolveComponent("AccPageRightNav")!
  const _component_app_right_nav = _resolveComponent("app-right-nav")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!

  return (_openBlock(), _createBlock(_component_app_main_layout, null, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    "bottom-nav": _withCtx(() => [
      _createVNode(_component_app_bottom_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: false }, {
        left: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-back"
              }))
            : _createCommentVNode("", true)
        ]),
        center: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { "nav-title": "" }, "Account", -1)
        ]))]),
        right: _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
        bottom: _withCtx(() => [...(_cache[2] || (_cache[2] = []))]),
        _: 1
      })
    ]),
    middle: _withCtx(() => [
      _createVNode(_component_AccPageHeader, { padded: true }, {
        icon: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_User, { primary: "" })
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", null, "Control how you experience the E4T platform", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_app_user_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_app_section_divider, { content: "Email" }),
            _createElementVNode("p", null, [
              _createVNode(_component_el_tag, {
                "is-all-borderless": "",
                type: "info"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.user.email), 1)
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.user.type === 'talent')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_app_section_divider, { content: "Available For Bids?" }),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_switch, {
                    onChange: _ctx.changeAvailability,
                    "model-value": _ctx.availableForBids,
                    style: {"margin-left":"24px"},
                    "active-icon": _ctx.Check,
                    "inactive-icon": _ctx.Close,
                    "active-text": "Available",
                    "inactive-text": "Unavailable"
                  }, null, 8, ["onChange", "model-value", "active-icon", "inactive-icon"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ChangePasswordComponent)
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_right_nav, null, {
        default: _withCtx(() => [
          _createVNode(_component_AccPageRightNav)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}